import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { adminLogin, adminLogout, adminAuthStatus } from "../api/adminUserApi";
import { notifications } from "@mantine/notifications";
import { AdminUser } from "../types/types";

const AuthContext = createContext<{
  adminUser: AdminUser;
  isAuthenticated: any;
  login: (username: string, phone: string, password: string) => void;
  logout: () => void;
}>(null!);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [adminUser, setAdminUser] = useState<AdminUser>(null);
  const [isAuthenticated, setIsAuthenticated] = useState<any>(null);
  const [token, setToken] = useState<string>("");
  const hasFetched = useRef(false); // İlk isteği kontrol etmek için

  useEffect(() => {
    if (hasFetched.current) return; // İkinci çalışmayı engelle
    hasFetched.current = true;
    const storedToken = localStorage.getItem("token");

    if (storedToken) {
      authStatus(storedToken);
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  const authStatus = async (token: string) => {
    const res: any = await adminAuthStatus(token);
    if (res?.data?.loggedIn) {
      setToken(res?.data.token);
      localStorage.setItem("token", res?.data?.token);
      setIsAuthenticated(true);
      setAdminUser(res?.data?.user);
    } else {
      setIsAuthenticated(false);
      setAdminUser(null);
      setToken("");
      localStorage.removeItem("token");
    }
    return res;
  };

  const login = async (username: string, phone: string, password: string) => {
    const res: any = await adminLogin(username, phone, password);
    if (res?.data?.success && res?.data?.token) {
      setAdminUser(res?.data?.user);
      setToken(res?.data?.token);
      localStorage.setItem("token", res?.data?.token);
      setIsAuthenticated(true);
      notifications.show({
        title: `Giriş Başarılı ${res?.data?.user.name} !`,
        message: `Hoş Geldiniz.`,
        autoClose: 4000,
        withBorder: true,
        color: "green",
      });
    } else {
      notifications.show({
        title: "Hata!",
        message: res?.response?.data?.message ?? "Giriş başarısız.",
        autoClose: 4000,
        withBorder: true,
        color: "red",
      });
    }
  };

  const logout = async () => {
    const res: any = await adminLogout(token);
    if (res.data.loggedout) {
      notifications.show({
        title: "Çıkış Başarılı " + adminUser?.name + " !",
        message: `İyi Günler Dileriz.`,
        autoClose: 4000,
        withBorder: true,
        color: "green",
      });
      setAdminUser(null);
      setToken("");
      setIsAuthenticated(false);
      localStorage.removeItem("token");
    }
  };

  return (
    <AuthContext.Provider value={{ adminUser, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
